import PropTypes from 'prop-types';

import styles from './upload-file-components.module.scss';

export function UploadFileHeader({ title = 'Upload file', subtitle = 'Accepted format: CSV, up to 10 MB' }) {
  return (
    <header className={styles.header}>
      <h4>{title}</h4>
      <div className={styles.subtitle}>{subtitle}</div>
    </header>
  );
}

UploadFileHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};
